module.exports = __webpack_public_path__ + "static/media/18_9.2a10e3fc.png";